import { DialogTrigger } from "@light-technology/components";
import { useState, type ReactNode } from "react";
import { api } from "../../state/api";
import type { AppResponse } from "../../state/api.types";
import { BasicModal } from "../shared/BasicModal";

type DeleteKeyModalProps = {
  app: AppResponse;
  clientId: string;
  children: ReactNode;
};

export const DeleteKeyModal = (props: DeleteKeyModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [deleteAPIKey, deleteAPIKeyResult] = api.useDeleteAPIKeyMutation();

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
      {props.children}
      <BasicModal
        textTitle="Are you sure you want to delete this app token?"
        textDescription="Any apps using this app token will no longer be able to access the API."
        textCancel="Cancel"
        textSubmit="Yes, delete"
        isDisabled={false}
        isLoading={deleteAPIKeyResult.isLoading}
        isDestructive={true}
        onCancel={() => {
          setIsOpen(false);
        }}
        onSubmit={() => {
          deleteAPIKey({
            appUUID: props.app.uuid,
            clientID: props.clientId,
          });
        }}
        data-ph-capture-attribute-action="delete-api-token"
      />
    </DialogTrigger>
  );
};
